module.exports = __webpack_public_path__ + "media/marqeta_setup/marqeta_front-23976bc6.png";